import React, {useEffect} from 'react';

type IframelyWindow = Window & {
  iframely?: {load: () => void};
};

export default function IframelyEmbed({url}: {url: string}) {
  useEffect(() => {
    const frame = requestAnimationFrame(() => {
      (window as IframelyWindow).iframely?.load();
    });
    return () => cancelAnimationFrame(frame);
  }, [url]);

  return (
    <div className="iframely-embed" data-testid="iframely-embed" data-url={url}>
      <div className="iframely-responsive">
        <a href={url} data-iframely-url rel="noreferrer" target="_blank">
          {url}
        </a>
      </div>
    </div>
  );
}
